module.exports = __webpack_public_path__ + "img/_add_hover.3b406411.svg";